import classNames from 'classnames';
import React from 'react';
import { areEqual, FixedSizeList, ListChildComponentProps } from 'react-window';
import { useRecoilValue } from 'recoil';
import {
  numberRankItemSelector,
  numberRankListSelector
} from 'src/modules/imagesV3/store/selector';
import { LIST_HEIGHT, RATIO } from '../list';
import RankItem from '../RanItem';
import styles from './index.module.scss';

const Row = React.memo(({ index, style, data }: ListChildComponentProps) => {
  const item = useRecoilValue(numberRankItemSelector(data[index]));
  if (!item) return null;
  return (
    <div style={style}>
      <RankItem
        rank={index + 1}
        score={item.score}
        renderLogo={() => (
          <div
            className={classNames(
              styles.avatar,
              index < 3 && styles[`rank${index + 1}`]
            )}
            style={{ backgroundImage: `url(${item.logoUrl})` }}
          />
        )}
        renderInfo={() => (
          <div className={styles.info}>
            <div className={styles.nickname}>{item.nickname}</div>
            <div className={styles.name}>{item.name}</div>
          </div>
        )}
      />
    </div>
  );
}, areEqual);
const NumberRank = () => {
  const list = useRecoilValue(numberRankListSelector);
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>排名</div>
        <div>昵称ID</div>
        <div>拥有数量</div>
      </div>
      <FixedSizeList
        className={styles.container}
        height={LIST_HEIGHT}
        itemSize={130 * RATIO}
        itemCount={list.length}
        width="100%"
        itemData={list}
      >
        {Row}
      </FixedSizeList>
    </div>
  );
};

export default React.memo(NumberRank);
